
//重置高血压表单数据
export function resetBloodFormData(temp){

  temp['asymptomatic'] = '';
  temp['symptomDizziness'] = '';
  temp['symptomNauseaVomiting'] = '';
  temp['symptomDazzleTinnitus'] = '';
  temp['symptomDyspnea'] = '';
  temp['symptomPalpitation'] = '';
  temp['symptomBinvBleeding'] = '';
  temp['symptomHandFootNumbness'] = '';
  temp['symptomJointGall'] = '';
  temp['symptomOther'] = '';
  temp['symptomOtherContent'] = '';
  temp['systolic'] = '';
  temp['diastolic'] = '';
  temp['height'] = '';
  temp['heartRate'] = '';
  temp['weight'] = '';
  temp['guideWeight'] = '';
  temp['weightType'] = '';
  temp['weightTypeName'] = '';
  temp['bmi'] = '';
  temp['guideBmi'] = '';
  temp['heartRateMinute'] = '';
  temp['somking'] = '';
  temp['somkingExp'] = '';
  temp['drink'] = '';
  temp['guideDrink'] = '';
  temp['drinkExp'] = '';
  temp['timesWeek'] = '';
  temp['timesWeekExp'] = '';
  temp['minsTimes'] = '';
  temp['minsTimesExp'] = '';
  temp['guideTimesWeek'] = '';
  temp['guideMinsTimes'] = '';
  temp['saltSituation'] = '';
  temp['guideSaltSituation'] = '1';
  temp['psychologyState'] = '';
  temp['psychologyStateName'] = '';
  temp['complianceState'] = '';
  temp['examineInfo'] = '';
  temp['drugState'] = '';
  temp['drugStateCode'] = '';
  temp['drugStateName'] = '';
  temp['adr'] = '';
  temp['adrRemark'] = '';
  temp['followupKind'] = '';
  temp['untowardEffect'] = '';
  temp['syndrome'] = '';
  temp['physicName1'] = '';
  temp['frequency1'] = '';
  temp['physicDose1'] = '';
  temp['physicUnit1'] = '';
  temp['physicName2'] = '';
  temp['frequency2'] = '';
  temp['physicDose2'] = '';
  temp['physicUnit2'] = '';
  temp['physicName3'] = '';
  temp['frequency3'] = '';
  temp['physicDose3'] = '';
  temp['physicUnit3'] = '';
  temp['physicName4'] = '';
  temp['frequency4'] = '';
  temp['physicDose4'] = '';
  temp['physicUnit4'] = '';
  temp['physicName5'] = '';
  temp['frequency5'] = '';
  temp['physicDose5'] = '';
  temp['physicUnit5'] = '';
  temp['physicName6'] = '';
  temp['frequency6'] = '';
  temp['physicDose6'] = '';
  temp['physicUnit6'] = '';
  temp['transferResonBlood'] = '';
  temp['transferResonDrug'] = '';
  temp['transferResonSerious'] = '';
  temp['transferReson'] = '';
  temp['transferOrgDept'] = '';
  temp['remark'] = '';
  temp['bpRange'] = ["", ""];
  return temp;
}


//重置糖尿病表单数据
export function resetGlucoseFormData(temp){

  temp['followupNo'] = '';
  temp['asymptomatic'] = '';
  temp['symptomPolydipsia'] = '';
  temp['symptomPolyphagia'] = '';
  temp['symptomPolyuria'] = '';
  temp['symptomBlurredVision'] = '';
  temp['symptomInfection'] = '';
  temp['symptomQuadriplegia'] = '';
  temp['symptomJointGall'] = '';
  temp['symptomWeightLoss'] = '';
  temp['symptomOther'] = '';
  temp['symptomOtherContent'] = '';
  temp['systolic'] = ["", ""];
  temp['diastolic'] = '';
  temp['height'] = '';
  temp['weight'] = '';
  temp['guideWeight'] = '';
  temp['weightType'] = '';
  temp['weightTypeName'] = '';
  temp['bmi'] = '';
  temp['guideBmi'] = '';
  temp['heartRate'] = '';
  temp['heartRateMinute'] = '';

  temp['footPulse'] = '';
  temp['footPulsex'] = '';
  temp['footPulsexs'] = '';
  temp['somking'] = '';
  temp['somkingExp'] = '';
  temp['drink'] = '';
  temp['guideDrink'] = '';
  temp['drinkExp'] = '';
  temp['timesWeek'] = '';
  temp['timesWeekExp'] = '';
  temp['minsTimes'] = '';
  temp['minsTimesExp'] = '';
  temp['guideTimesWeek'] = '';
  temp['guideMinsTimes'] = '';
  temp['saltSituation'] = '';
  temp['guideSaltSituation'] = '1';
  temp['psychologyState'] = '';
  temp['psychologyStateName'] = '';
  temp['complianceState'] = '';

  //主食重量
  temp['staple'] = '';
  temp['guideStaple'] = '';
  temp['strengthType'] = '';
  temp['strengthTypeLight'] = '';

  temp['fastingBloodGlucose'] = '';
  temp['bloodSugarTime'] = '';
  temp['bloodSugarTimeContain'] = '';
  temp['hbalc1'] = '';
  temp['hbalcDate'] = '';
  temp['otherExamine'] = '';
  temp['drugState'] = '';
  temp['drugStateCode'] = '';
  temp['drugStateName'] = '';
  temp['adr'] = '';
  temp['adrRemark'] = '';
  temp['hypoglycemia'] = '';
  temp['followupKind'] = '';
  temp['untowardEffect'] = '';
  temp['syndrome'] = '';
  temp['physicName1'] = '';
  temp['frequency1'] = '';
  temp['physicDose1'] = '';
  temp['physicUnit1'] = '';
  temp['physicName2'] = '';
  temp['frequency2'] = '';
  temp['physicDose2'] = '';
  temp['physicUnit2'] = '';
  temp['physicName3'] = '';
  temp['frequency3'] = '';
  temp['physicDose3'] = '';
  temp['physicUnit3'] = '';
  temp['physicName4'] = '';
  temp['frequency4'] = '';
  temp['physicDose4'] = '';
  temp['physicUnit4'] = '';
  temp['physicName5'] = '';
  temp['frequency5'] = '';
  temp['physicDose5'] = '';
  temp['physicUnit5'] = '';
  temp['physicName6'] = '';
  temp['frequency6'] = '';
  temp['physicDose6'] = '';
  temp['physicUnit6'] = '';
  temp['insulinKind'] = '';
  temp['insulinUsage'] = '';
  temp['transferResonGlucose'] = '';
  temp['transferResonDrug'] = '';
  temp['transferResonSerious'] = '';
  temp['transferReson'] = '';
  temp['transferOrgDept'] = '';
  temp['remark'] = '';
  temp['bpRange'] = ["", ""];
  temp['weightRange'] = ["", ""];
  temp['bmiRange'] = ["", ""];
  temp['smokeRange'] = ["", ""];
  temp['drinkRange'] = ["", ""];
  temp['stapleRange'] = ["", ""];
  return temp;
}




// 获取当前年份
export function getNowYear(){
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  return `${year}`;
}




// WEBPACK FOOTER //
// ./src/utils/ph/ChronicUtils.js